// extracted by mini-css-extract-plugin
export default {"PremierPageFrame":"PremierPageFrame_PremierPageFrame"};